import { z } from 'zod';
import { IdSchema, PageInfoSchema, TimestampSchema } from './common.js';
export const IntegrationStatusSchema = z.enum(['disconnected', 'connected', 'error', 'disabled']);
export const IntegrationConnectionSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    providerKey: z.string(),
    displayName: z.string(),
    status: IntegrationStatusSchema,
    lastSyncedAt: TimestampSchema.nullable(),
    lastErrorCode: z.string().nullable(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const CreateIntegrationConnectionRequestSchema = z.strictObject({
    providerKey: z
        .string()
        .trim()
        .min(1)
        .max(100)
        .regex(/^[a-z0-9]+(?:[-_.][a-z0-9]+)*$/),
    displayName: z.string().trim().min(1).max(200),
    credentialReference: z.string().trim().min(1).max(500),
});
export const UpdateIntegrationConnectionRequestSchema = z.strictObject({
    displayName: z.string().trim().min(1).max(200).optional(),
    credentialReference: z.string().trim().min(1).max(500).optional(),
    status: IntegrationStatusSchema.optional(),
});
export const IntegrationConnectionListSchema = z.strictObject({
    items: z.array(IntegrationConnectionSchema),
    page: PageInfoSchema,
});
export const WebhookReceiptSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    providerKey: z.string(),
    externalEventId: z.string(),
    receivedAt: TimestampSchema,
    processedAt: TimestampSchema.nullable(),
});
